const name = 'circle-j';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M27.84 55.293c-.884 0-1.671-.055-2.361-.166-.69-.11-1.34-.22-1.948-.331l.498-4.392a9.918 9.918 0 002.237.249c.884 0 1.533-.29 1.947-.87.414-.58.621-1.284.621-2.113V26.707h5.635V47.92c0 4.916-2.21 7.374-6.629 7.374z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'J',
};

export default icon;
